import React from 'react';
import { Box, GridItem } from '@chakra-ui/react';

const Tropicana = () => {
  return (
    <Box>
      <Box as="h1" fontSize="34px" textTransform="uppercase" mb={5}>
        Tropicana
      </Box>
      <GridItem as="p">Refonte de l'identité visuelle d'une marque de jus de fruits.</GridItem>
      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [Objectifs]
      </Box>
      <GridItem as="p" mb={5}>
        Refonte de la charte graphique d’une marque de jus de fruits, visant à moderniser son image pour attirer une clientèle jeune (18-35 ans) et mettre en avant des valeurs de durabilité et
        d’innovation. Livrables : analyse du site existant, wireframe, moodboard créatif, palette de couleurs, typographies, logo revisité et mockup produit.
      </GridItem>
      <GridItem as="p" mb={5}>
        Proposition d’une nouvelle identité visuelle avec un design écoresponsable, tout en conservant l’essence de la marque.
      </GridItem>
      <GridItem as="p">Livrables : analyse du site existant, wireframe, moodboard créatif, palette de couleurs, typographies, logo revisité et mockup produit.</GridItem>
      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [LIENS]
      </Box>
      <a href="https://www.figma.com/deck/4jz2FADHriDqVSV8JmCaFa/Tropicana?node-id=13-213&t=cogTnzPkRSChVYka-1" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline' }}>
        Slide deck Tropicana
      </a>
    </Box>
  );
};

export default Tropicana;
